export default "__VITE_ASSET__DxEykX_W__"